import gql from "graphql-tag";

export const updateBonusProgramTextMutation = gql`
  mutation updateBonusProgramText($id: ID!, $title: String!, $content: String!) {
    updateBonusProgramText(id: $id, title: $title, content: $content) {
      id
    }
  }
`;
